<template>
  <component
    :is="as"
    class="card-note"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <card-image :image-url="imageUrl" />
    <div v-html="cardNote.text" />
  </component>
</template>

<script>
import CardImage from './CardImage';

import { toImageUrl } from '@cardladder/shared/utils/format.util';

export default {
  components: {
    CardImage,
  },

  props: {
    cardNote: Object,
    as: {
      type: String,
      default: 'div',
    },
  },

  computed: {
    imageUrl() {
      return toImageUrl(`cards/thumb_${this.cardNote.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.card-note {
  color: var(--theme-color);
  text-decoration: none !important;
  font-weight: normal;
  display: flex;
  align-items: flex-start;
  padding: $gp;

  .card-image {
    margin-right: $gp;
    --card-image-width: 80px;
    min-width: 80px;
  }

  &:hover {
    background-color: var(--theme-highlight);
    cursor: pointer;
  }
}
</style>
